(function () {
  'use strict';

  function triggerVideoMedia() {
    // Il tema usa web component <video-media> con Shadow DOM
    document.querySelectorAll('video-media').forEach(function (el) {
      // Prova a chiamare il metodo play interno del componente
      if (typeof el.playVideo === 'function') el.playVideo();
      if (typeof el.play === 'function') el.play();

      // Forza attributo loaded per rimuovere overlay play
      el.setAttribute('loaded', '');

      // Accedi al video dentro il shadow root
      var shadow = el.shadowRoot;
      if (shadow) {
        shadow.querySelectorAll('video').forEach(function (video) {
          video.muted = true;
          video.setAttribute('muted', '');
          video.play().catch(function () {});
        });
      }

      // Prova anche il video diretto (fuori shadow)
      el.querySelectorAll('video').forEach(function (video) {
        video.muted = true;
        video.setAttribute('muted', '');
        video.play().catch(function () {});
      });
    });
  }

  [500, 1000, 2000, 3000].forEach(function (delay) {
    setTimeout(triggerVideoMedia, delay);
  });

  new MutationObserver(function () {
    triggerVideoMedia();
  }).observe(document.body, { childList: true, subtree: true });

})();
